var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullphishIdIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 150 150"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bullphishIdIco_svg__cls-2{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bullphishIdIco_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bullphishIdIco_svg__Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140 150H8a8 8 0 01-8-8V8a8 8 0 018-8h132a10 10 0 0110 10v130a10 10 0 01-10 10z",
    fill: "#003099"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bullphishIdIco_svg__cls-2",
    d: "M110.3 67.3a6.6 6.6 0 10-10.4 5.2V91l-26.5 15.8L46.9 91V59.1l26.8-15.9 7 3.4c0 .1-.1.3-.1.4a6.5 6.5 0 106.5-6.5 5.8 5.8 0 00-2.6.6L73 35 39.7 55.1V95l33.7 20L107 95V72.8a6.3 6.3 0 003.3-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bullphishIdIco_svg__cls-2",
    d: "M55.3 66.7h11a5.9 5.9 0 014.2 1.3 4.5 4.5 0 011.5 3.4 4.3 4.3 0 01-1 2.9 5.4 5.4 0 01-2.1 1.3 4.9 4.9 0 013 1.7 4.4 4.4 0 011 3 5 5 0 01-.7 2.7 5.5 5.5 0 01-1.9 1.8 7.1 7.1 0 01-2.2.7l-2.6.2H55.3zm5.9 7.4h2.6a3.2 3.2 0 001.9-.4 1.6 1.6 0 00.5-1.4 1.4 1.4 0 00-.5-1.3 3.1 3.1 0 00-1.9-.5h-2.6zm0 7.5h3a4 4 0 002.2-.5 2 2 0 00.6-1.5 1.6 1.6 0 00-.6-1.3 3.3 3.3 0 00-2.2-.5h-3zM75.7 66.7h9.8a6.5 6.5 0 014.7 1.5 5.4 5.4 0 011.6 4.3 5.7 5.7 0 01-1.7 4.5c-1.2 1.1-2.9 1.6-5.3 1.6h-3.2v7.1h-5.9zm5.9 8.1H83a3.5 3.5 0 002.4-.6 1.8 1.8 0 00.7-1.5 2 2 0 00-.6-1.5 3 3 0 00-2.2-.7h-1.7z"
  })))));
}
export default SvgBullphishIdIco;